define(["require", "exports", "./context", "./facebookApi", "./dialogs/promptSignup", "./dialogs/signup"], function (require, exports, context_1, facebookApi_1, promptSignup_1, signup_1) {
    "use strict";
    exports.__esModule = true;
    var promptDelay = 5;
    function findAnchorInViewport($sel) {
        var $win = $(window);
        var winHeight = $win.height();
        var winWidth = $win.width();
        return $sel.filter(function (i, el) {
            var rect = el.getBoundingClientRect();
            return rect.top >= 0 && rect.bottom < winHeight && rect.left >= 0 && rect.right <= winWidth;
        });
    }
    function promptNewsLetterSubscripton(show, promptIntervalHours, promptDelayInSeconds, offer) {
        if (promptDelayInSeconds === void 0) { promptDelayInSeconds = 5; }
        if (!context_1["default"].isUserLoggedIn()) {
            var prompted_1 = sessionStorage.getItem('promptSignup');
            if (show) {
                setTimeout(function () {
                    if (!prompted_1) {
                        sessionStorage.setItem('promptSignup', 'prompted');
                        promptSignup_1["default"](offer.body, offer.saving, prompted_1 === 'prompted');
                    }
                }, promptDelayInSeconds * 1000);
            }
        }
    }
    function shouldPromptNewsLetter() {
        if (context_1["default"].isUserLoggedIn()) {
            return $.Deferred().resolve(false);
        }
        var deferred = $.Deferred();
        facebookApi_1.getLoginStatus(deferred);
        return deferred.then(function (status) {
            var show = !facebookApi_1.isCeluce() && context_1["default"].isMobile() ||
                status != facebookApi_1.LoginStatus.connected;
            return $.Deferred().resolve(show);
        }, function (err) {
            console.warn(err);
            return $.Deferred().reject(err);
        });
    }
    function signupNewUser(offer, e) {
        e.preventDefault();
        var deferred = $.Deferred();
        facebookApi_1.getLoginStatus(deferred);
        return deferred.then(function (status) {
            if (status == facebookApi_1.LoginStatus.not_authorized) {
                return facebookApi_1.logInCeluce();
            }
            else {
                signup_1["default"]();
                return $.Deferred().resolve();
            }
        });
    }
    function promptNewsLetter(show, emailDeltaHours, delaySeconds, offer) {
        if (context_1["default"].isMobile()) {
            facebookApi_1.fbInited
                .then(shouldPromptNewsLetter)
                .then(function (show) {
                if (show) {
                    var prompted_2 = sessionStorage.getItem('promptSignup');
                    var message_1 = offer.body || "Save $" + (offer.saving || 100).toFixed(0) + " on your first order of $" + (offer.amount || 200).toFixed(0) + " or more";
                    if (!prompted_2) {
                        sessionStorage.setItem('promptSignup', 'prompted');
                    }
                    setTimeout(function () {
                        promptSignup_1["default"](message_1, offer.saving, prompted_2 === 'prompted');
                    }, delaySeconds * 1000);
                }
            });
        }
        else {
            promptNewsLetterSubscripton.apply(this, arguments);
        }
    }
    exports["default"] = promptNewsLetter;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/promptNewsLetter.js
// module id = 65
// module chunks = 0